import { FC, useState } from 'react'
import { Box, styled, useTheme } from '@mui/material'
import { Modal } from 'components/Modal'
import { PasswordInput } from 'components/PasswordInput'
import { ItemDetails } from 'components'
import { useTranslation } from 'react-i18next'
import { ValidationMessage } from 'packages/eid-ui'

// eslint-disable-next-line
const TextButton = styled(Box)(({ theme }) => ({
    color: theme?.palette?.primary?.main,
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '56px',
    '&:hover': {
        cursor: 'pointer',
    },
}))

export interface EnterPasswordProps {
    open?: any
    onClose?: any
    onReset?: any
    onCancel?: any
    onSucces?: any
    loading?: boolean
    error?: boolean
}

export const EnterPassword: FC<EnterPasswordProps> = (props) => {
    const { open, onClose, onSucces, onCancel, loading, error } = props
    const [value, setValue] = useState('')
    const { t } = useTranslation()
    const theme = useTheme()

    const footerContent = (
        <Box display="flex" width="100%" padding="24px 32px">
            <Box minWidth="88px">
                <ItemDetails.ActionButton
                    fontColor={theme?.palette?.common?.white}
                    bgColor={theme?.palette?.primary?.main}
                    width="fit-content"
                    minWidth="100%"
                    loading={loading}
                    onClick={() => onSucces(value)}
                >
                    {t('Common_Ok')}
                </ItemDetails.ActionButton>
            </Box>

            <Box minWidth="130px" pl="30px">
                <ItemDetails.ActionButton
                    fontColor={theme?.palette?.common?.white}
                    bgColor={'#aab0b4'}
                    width="fit-content"
                    minWidth="100%"
                    onClick={onCancel}
                >
                    {t('Common_Cancel')}
                </ItemDetails.ActionButton>
            </Box>

            {/* TODO:Enable when reset master password feature introduced
            <TextButton onClick={onReset}>
                {t('ResetPassword')}
            </TextButton> */}
        </Box>
    )

    const handleOnChange = (event: any) => {
        setValue(event.currentTarget.value)
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={t('EnterYourMasterPasswordToContinue')}
            footerContent={footerContent}
        >
            <Box>
                <PasswordInput
                    value={value}
                    error={error}
                    onChange={handleOnChange}
                    style={{ fontSize: 18 }}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            onSucces(value)
                        }
                    }}
                />
                {error && (
                    <ValidationMessage message={t('InvalidPasswordMessage')} />
                )}
            </Box>
        </Modal>
    )
}
